import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
import { useLoadingStore } from '../store/loadingStore';

/**
 * Indikator loading tingkat aplikasi: progress bar tipis di atas konten
 * dan pill status yang menyebut aktivitas yang sedang berjalan.
 */
export function GlobalLoadingBar() {
  const tasks = useLoadingStore(state => state.tasks);
  const labels = Object.values(tasks);
  const active = labels.length > 0;
  return <>
      <AnimatePresence data-id="element-108" data-mp="1snpu6z1fo2g2">
        {active && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: 'easeOut'
      }} className="absolute top-0 left-0 right-0 h-[2px] z-50 overflow-hidden pointer-events-none" role="progressbar" aria-label="Memuat data" data-id="element-109" data-mp="1smy423qluwx6">
            <div className="loading-track h-full w-full" data-id="element-110" data-mp="88nxddw58cu0" />
          </motion.div>}
      </AnimatePresence>

      <AnimatePresence data-id="element-111" data-mp="17oqy7lmps1m2">
        {active && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} className="absolute top-3 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-950/92 border border-cyan-400/25 shadow-glow pointer-events-none" aria-live="polite" data-id="element-112" data-mp="1cmipcdfjbjp7">
            <Loader2Icon size={12} className="animate-spin text-cyan-400" data-id="element-113" data-mp="1vbp6vx4le59f" />
            <span className="text-[11px] font-mono text-cyan-100 truncate max-w-[280px]" data-id="element-114" data-mp="20btsu2o9rs71">
              {labels[0]}
            </span>
            {labels.length > 1 && <span className="text-[10px] font-mono text-slate-500" data-id="element-115" data-mp="5y2bsi3m261k">
                +{labels.length - 1}
              </span>}
          </motion.div>}
      </AnimatePresence>
    </>;
}